import axios from '@/allotment/axios'

export default {
  save: data => axios.post('/product/save', data), //保存产品
  delete: id => axios.post('/product/delete', { id }), //删除产品
  select: () => axios.get('/product/select'), //获取产品选择列表
  page: params => axios.get('/product/page', { params }) //获取产品分页
}